export class epalDeviceSpareParts{
    eloViewSerialNumber: string;
    deviceApplicationType: string;
    epalHardwareId: string;        
}